module.exports = __webpack_public_path__ + "static/media/loewy logo-04.2b77a5d2.png";